import VisitasIndex from '../visitas/pages/VisitasIndex.vue';
import { laisPath } from '../laisRouteHelpers';

export default {
  path: laisPath('visitas-agendadas'),
  component: VisitasIndex,
  meta: {
    referenceAuthenticated: true,
  },
};
